import "core-js/modules/es6.function.name";
import _slicedToArray from "/Users/dlynch/code/websites/mathapedia.com/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.trim";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function Parser(LaTeX2JS) {
  this.Ignore = LaTeX2JS.Ignore;
  this.Delimiters = LaTeX2JS.Delimiters;
  this.Text = LaTeX2JS.Text;
  this.PSTricks = LaTeX2JS.PSTricks;
  this.Headers = LaTeX2JS.Headers;
  this.objects = [];
  this.environment = null; // emulating a match

  this.settings = this.PSTricks.Functions.psset.call(this, ['', 'units=1cm,linecolor=black,linestyle=solid,fillstyle=none']);
}

Parser.prototype = {
  parse: function parse(text) {
    var _this = this;

    if (!text) return {};
    var lines = text.split('\n');
    this.parseEnvText(lines);
    this.parseEnv(lines);
    this.objects.forEach(function (obj) {
      if (obj.type.match(/pspicture/)) {
        obj.plot = _this.parsePSTricks(obj.lines, obj.env);
      }
    });
    return this.objects;
  },
  newEnvironment: function newEnvironment(type) {
    if (this.environment && this.environment.lines.length) {
      this.environment.settings = _objectSpread({}, this.settings);
      this.objects.push(this.environment);
    }

    this.environment = {
      type: type,
      lines: []
    };
  },
  pushLine: function pushLine(line) {
    var add = true;
    this.Ignore.forEach(function (exp) {
      if (exp.test(line)) {
        add = false;
      }
    });

    if (add) {
      if (typeof line === 'string' && line.trim().length) {
        if (this.PSTricks.Expressions.psset.test(line)) {
          this.parseUnits(line);
        } else {
          this.environment.lines.push(line);
        }
      }
    }
  },
  parseUnits: function parseUnits(line) {
    var m = line.match(this.PSTricks.Expressions.psset);
    Object.assign(this.settings, this.PSTricks.Functions.psset.call(this, m));
  },
  metaData: function metaData(environment, line) {
    if (this.PSTricks.Expressions.hasOwnProperty(environment)) {
      this.environment.match = line.match(this.PSTricks.Expressions[environment]);
      this.environment.env = this.PSTricks.Functions[environment].call(this.settings, this.environment.match);

      if (environment.match(/pspicture/)) {
        if (typeof this.environment.env.xunit === 'undefined') {
          this.environment.env.xunit = this.settings.xunit;
        }

        if (typeof this.environment.env.yunit === 'undefined') {
          this.environment.env.yunit = this.settings.yunit;
        }
      }
    }
  },
  parseEnv: function parseEnv(lines) {
    var _this2 = this;

    this.objects = [];
    this.environment = {
      type: 'math',
      lines: []
    };
    var Delimiters = this.Delimiters;
    var print = false;
    lines.forEach(function (line) {
      var isDelim = false;
      Object.entries(Delimiters).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            env = _ref2[0],
            type = _ref2[1];

        Object.entries(type).forEach(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
              k = _ref4[0],
              delim = _ref4[1];

          if (line.match(delim)) {
            isDelim = true;

            if (k.match(/begin/)) {
              if (_this2.environment.type.match(/verbatim/)) {
                isDelim = false;
              } else if (_this2.environment.type.match(/print/)) {
                isDelim = false;
              } else {
                _this2.newEnvironment(env);

                _this2.metaData(env, line);
              }
            } else if (k.match(/end/)) {
              if (_this2.environment.type.match(/verbatim/)) {
                if (env.match(/verbatim/)) {
                  _this2.newEnvironment('math');
                } else {
                  isDelim = false;
                }
              } else if (_this2.environment.type.match(/print/)) {
                if (env.match(/print/)) {
                  _this2.newEnvironment('math');
                } else {
                  isDelim = false;
                }
              } else {
                _this2.newEnvironment('math');
              }
            }
          }
        });
      });
      if (!isDelim) _this2.pushLine(line); // }
    }); // push last!

    this.newEnvironment('math');
  },
  parseEnvText: function parseEnvText(lines) {
    var _this3 = this;

    var _env = 'math';
    var Delimiters = this.Delimiters;
    lines.forEach(function (line, i) {
      var isDelim = false;
      Object.entries(Delimiters).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            env = _ref6[0],
            type = _ref6[1];

        Object.entries(type).forEach(function (_ref7) {
          var _ref8 = _slicedToArray(_ref7, 2),
              k = _ref8[0],
              delim = _ref8[1];

          if (line.match(delim)) {
            isDelim = true;

            if (k.match(/begin/)) {
              if (!_env.match(/verbatim/)) {
                _env = env;
              } else {
                isDelim = false;
              }
            } else if (k.match(/end/)) {
              if (!_env.match(/verbatim/)) {
                _env = 'math';
              } else {
                if (!env.match(/verbatim/)) {
                  isDelim = false;
                } else {
                  _env = 'math';
                }
              }
            }
          }
        });
      });

      if (!isDelim) {
        if (!_env.match(/verbatim/)) {
          lines[i] = _this3.parseText(line);
        }

        if (!line.trim().length) {
          lines[i] = '<br>';
        }
      }
    });
  },
  parsePSExpression: function parsePSExpression(line, exp, plot, k, env) {
    var match = line.match(exp);

    if (match) {
      plot[k].push({
        data: this.PSTricks.Functions[k].call(env, match),
        env: env,
        match: match,
        fn: this.PSTricks.Functions[k]
      });
      return true;
    }

    return false;
  },
  parsePSVariables: function parsePSVariables(line, exp, plot, k, env) {
    var match = line.match(exp);

    if (match) {
      if (k.match(/uservariable/)) {
        var dd = this.PSTricks.Functions[k].call(env, match);
        env.variables = env.variables || {};
        env.variables[dd.name] = dd.value;
      }
    }
  },
  parsePSTricks: function parsePSTricks(lines, env) {
    var _this4 = this;

    var plot = {};
    var entries = Object.entries(this.PSTricks.Expressions);
    entries.forEach(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          k = _ref10[0],
          exp = _ref10[1];

      plot[k] = [];
    });
    lines.forEach(function (line) {
      entries.forEach(function (_ref11) {
        var _ref12 = _slicedToArray(_ref11, 2),
            k = _ref12[0],
            exp = _ref12[1];

        _this4.parsePSVariables(line, exp, plot, k, env);

        _this4.parsePSExpression(line, exp, plot, k, env);
      });
    });
    return plot;
  },
  parseTextExpression: function parseTextExpression(line, exp, k, contents) {
    var match = line.match(exp);

    if (match) {
      return this.Text.Functions[k].call(this, match, contents);
    }

    return contents;
  },
  parseHeadersExpression: function parseHeadersExpression(line, exp, k, contents) {
    var match = line.match(exp);

    if (match) {
      return this.Headers.Functions[k].call(this);
    }

    return contents;
  },
  parseText: function parseText(line) {
    var _this5 = this;

    var contents = line; // TEXT

    Object.entries(this.Text.Expressions).forEach(function (_ref13) {
      var _ref14 = _slicedToArray(_ref13, 2),
          k = _ref14[0],
          exp = _ref14[1];

      contents = _this5.parseTextExpression(line, exp, k, contents);
    }); // HEADERS

    Object.entries(this.Headers.Expressions).forEach(function (_ref15) {
      var _ref16 = _slicedToArray(_ref15, 2),
          k = _ref16[0],
          exp = _ref16[1];

      contents = _this5.parseHeadersExpression(line, exp, k, contents);
    });
    return contents;
  }
};
export default Parser;